import React, { useState } from "react";
import { useAgencyInfo } from "../../../context/agency";
import { INTEGRATION_Data } from "./Constant";
import Select from 'react-select'
import { Button } from "reactstrap";
import { useAppServices } from "../../../hook/services";
interface PropsType {
  users: any[]
}
const ActiveUsers = ({ users }: PropsType) => {
  const [agency] = useAgencyInfo()
  const Service = useAppServices()
  const [activeUsers, setActiveUsers] = useState<any[]>(agency?.active_users || [])
  const userOptions = users.map((item) => ({
    ...item,
    label: item.username,
    value: item.id,
  }))
  const handleSubmit = async (e: any) => {
    e.preventDefault()
    const payload = {
      active_users: activeUsers,
      _id: agency?._id
    }
    console.log(payload, 'payload')
    const { response } = await Service.agency.update({ payload })
    if (response) {
    }
  }
  return (
    <div className="accordion-body" >
      <form onSubmit={handleSubmit}>
        <div>

          <p className="text-muted mb-1" style={{ fontSize: '13px' }}>users</p>
          <Select value={activeUsers} onChange={(e: any) => setActiveUsers(e)} isMulti options={userOptions} name="active_users" />
        </div>
        <div className="mt-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>

          <Button type="submit" color="success" >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ActiveUsers;
